import { useApiQuery } from '@apps/web/swr_data_fetching/use_api_query';

export function useTrainingCoverage({
    organizationId,
}: {
    readonly organizationId: string | null;
}) {
    return useApiQuery({
        path: '/organizations/{organization_id}/training-coverage',
        method: 'get',
        pathParams: organizationId
            ? { organization_id: organizationId }
            : undefined,
        enabled: !!organizationId,
        select: (response) => response,
        reason: 'training-coverage-dashboard',
    });
}

export function useCaregiverGapPage({
    organizationId,
    gapType,
    query,
    offset,
    limit,
    enabled,
}: {
    readonly organizationId: string | null;
    readonly gapType: 'availability' | 'memory';
    readonly query: string;
    readonly offset: number;
    readonly limit: number;
    readonly enabled: boolean;
}) {
    return useApiQuery({
        path: '/organizations/{organization_id}/training-coverage/gaps/{gap_type}',
        method: 'get',
        pathParams: organizationId
            ? { organization_id: organizationId, gap_type: gapType }
            : undefined,
        queryParams: { query, offset, limit },
        enabled: enabled && !!organizationId,
        select: (response) => response,
        reason: 'training-coverage-gap-list',
    });
}
